<template>
  <el-container class="view-box-padding">
    <el-main style="border-radius:20px;background-color:#ffffff;height:100%;">
      <el-container  style="height:100%" class="iphone_sm">
        <el-main v-loading="isLoading" class="scrollbars scrollbars_pc">
          <div style="overflow-y:auto;height:100%;box-sizing:border-box;" class="geofencesPosition">
            <!-- <div class="allgeofences flex-row-between" @click="getAlldatas" style="padding:0 10px;">
              <div>
                <div :class=" onAll ? 'blueBorder' : 'nullBorder'"></div>
                <img :src="$Image('loc.png')" alt="" style="padding-left:8px;">
                <span style="margin-left:10px;">{{$t('message.AllGeofences')}}</span>
              </div>
            </div> -->
            <!-- 添加按钮 -->
            <div class="addBox" @click="onAddButten">
              <el-button class="normalBtn buy-footer-btn">{{$t('Add geofence')}}</el-button>
            </div>
            <!-- 左边有数据 -->
            <el-table
              v-if="geofencesDatas.length>0"
              :data="geofencesDatas"
              :show-header="false"
              height="scroll"
              @row-click="getCurrentRow"
              :cell-style="cellStyle"
              style="width: 100%;height:80%;font-weight:600;margin-top:30px">
              <!-- 左边栏图标名称删除 -->
              <el-table-column
              width="46px"
              style="height:56px;box-sizing:border-box;">
                <template slot-scope="scope">
                  <div :class="scope.row === currentNum && !onAll? 'blueBorder' : 'nullBorder'"></div>
                  <div class="avatar" style="padding:20px 10px">
                    <img :src="$Image('loc.png')" alt="">
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="geofencesPosition">
                <template slot-scope="scope">
                  <div class="messageTitle">
                    <p :title="scope.row.title" class="tableEllipsis">{{scope.row.title}}</p>
                    <div class="geofencesDelete">
                      <img :src="$Image(scope.row === currentNum && !onAll? 'delete_hover.png' : 'delete.png')" alt="" @click="onDelete(scope.row, $event)">
                      <!-- <i class="el-icon-close" style="font-weight:bold;" @click="onDelete(scope.row, $event)"></i> -->
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 左边没有数据 -->
            <div v-else style="width:100%;height:100%;background-color:#f6f6f6;" class="flex-col-start">
              <img style="padding-top: 30%" :src="$Image('nodata.png')" alt="">
              <div style="padding: 10%;" class="defaultView defaultView_nodata">{{$t('Add location range, you will be notified whenchildren access location range')}}</div>
            </div>
            <!-- 删除弹框提示 -->
            <el-dialog
              :visible.sync="dialogVisible"
              title="Tips"
              :show-close = 'false'
              class="dialog-disconnect"
              style="border-radius: 20px;"
              center>
              <div class="flex-col-center demo--dialog-body"><span>{{$t('Are you sure you want to select the deleted geofence ?')}}</span></div>
              <span slot="footer" class="dialog-footer demo-dialog-footer">
                <el-button class="delete-account-button" type="primary" size="medium" round @click="onDetermine">{{$t('Yes')}}</el-button>
                <el-button class="delete-account-button" round size="medium" @click="handleClose">{{$t('No')}}</el-button>
              </span>
            </el-dialog>
          </div>
        </el-main>
        <el-aside v-loading="isLoading" class="GeofencesAside GeofencesAside_pc">
          <div class="flex-row-end select_date">
            <el-select v-model="selectDate" @change="changeSelect" size="mini" placeholder="Today" class="select_time">
              <el-option
                v-for="(date, i) in allDates" :key="i" :label="date" :value="date">
              </el-option>
            </el-select>
          </div>
          <div v-if="noResultDetail" style="width:100%;height:80%;margin-top:20px;background-color:#ffffff;" class="flex-col-center">
            <img :src="$Image('nodata.png')" alt="">
            <div class="defaultView">{{$t('No data found')}}</div>
          </div>
          <!-- 进入图标时间显示 -->
          <div v-else class="asideText">
            <div class="detailBox" v-for='(item, i) in currentRow' :key="i">
              <div>
                <img :src="item.exitDate ? $Image('ico_out.png') : $Image('ioc_in.png')" alt="">
                <span :class="item.exitDate ? 'Out_in' : 'Out_ins'">{{item.exitDate ? $t('Out') : $t('In')}}</span>
                <div>{{getcurrentDate(item.exitDate)}}</div>
              </div>
              <div class="dateFont">{{dateFormatter(item.exitDate ? item.exitDate : item.enterDate)}}</div>
            </div>
          </div>
        </el-aside>
        <!-- 没有数据显示PC -->
        <!-- <el-aside v-else style="width:60%;height:100%;overflow-y:auto" class="GeofencesAside scrollbars geofences_nodata">
            <div class="flex-row-end select_date">
              <el-select v-model="selectDate" @change="changeSelect" size="mini" placeholder="Today" class="select_time">
                <el-option
                  v-for="(date, i) in allDates" :key="i" :label="date" :value="date">
                </el-option>
              </el-select>
            </div>
            <div v-if="!noResultAll">
            </div>
            <div v-else style="width:100%;height:80%;margin-top:20px;" class="flex-col-center">
              2222222222222
              <img :src="$Image('nodata.png')" alt="">
              <span class="defaultView">{{$t('No data found')}}</span>
            </div>
        </el-aside> -->
      </el-container>
    </el-main>
    <!-- 移动端 -->
  </el-container>
</template>

<script>
import { tryItNow } from './api/cookies.js'
export default {
  name: 'Geofences',
  data () {
    return {
      isLoading: false,
      onAll: true,
      showDetailView: false,
      isAddView: false,
      allview: false,
      geofencesDatas: [],
      allGeofencesDatas: [],
      dialogVisible: false,
      noResultDetail: true,
      noResultAll: true,
      dialogTitle: '',
      currentRow: '',
      currentRowTitle: '',
      currentNum: '',
      id: '',
      deletId: '',
      warning: false,
      accountLevel: false,
      addBtnShow: false,
      activeNames: [],
      showAuthPrompt: false,
      selectDate: this.$t('Today'),
      allDates: [this.$t('Today'), this.$t('Yesterday'), this.$t('Last 7 Days')]
    }
  },
  methods: {
    changeSelect (e) {
      this.selectDate = e
      this.getCurrentRow(this.currentNum)
    },
    tryItNow () {
      tryItNow()
    },
    handleChange (val) {
      console.log(val)
      // this.allGeofencesDatas = []
      this.getCurrentRow(val, 'mobile')
    },
    getcurrentDate (date) {
      console.log(date)
    },
    onDelete (row, e) {
      let event = window.event || e
      event.stopPropagation()
      console.log(row, e)
      this.deletId = row.id
      this.dialogVisible = true
      this.dialogTitle = row.title
    },
    handleClose () {
      this.dialogVisible = false
    },
    async onDetermine () {
      console.log(this.deletId)
      const result = await this.$http.get('MDM/Geofences/Delete', {
        params: {
          id: this.deletId
        }
      })
      if (result.statusText === 'OK') {
        this.$message({
          showClose: true,
          message: this.$t('Deleted Success Fully'),
          type: 'success'
        })
        this.dialogVisible = false
        this.getGeofencesdatas()
      }
    },
    onAddButten () {
      this.$router.push({ path: `/User/${this.$route.params.userid}/${this.$route.params.device}/GeofencesAdd` })
      // if (this.geofencesDatas.length >= 5) {
      //   this.warning = true
      //   setTimeout(() => { this.warning = false }, 2000)
      // } else {
      //   this.$router.push({ path: `/User/${this.$route.params.userid}/${this.$route.params.device}/GeofencesAdd` })
      // }
    },
    async getGeofencesdatas () {
      this.isLoading = true
      try {
        const Geofences = await this.$http.get('MDM/Geofences')
        this.accountLevel = Geofences ? !Geofences.data.enable : false
        this.showAuthPrompt = Geofences ? !Geofences.data.auth : false
        console.log(this.accountLevel)
        console.log(this.showAuthPrompt)
        this.addBtnShow = Geofences ? !Geofences.data.enable : false
        console.log(this.addBtnShow)
        this.geofencesDatas = Geofences.data.data
        console.log(Geofences)
        console.log(this.geofencesDatas)
        this.isLoading = false
      } catch (error) {
        console.log(error)
      }
    },
    async getCurrentRow (row) {
      this.isLoading = true
      console.log(row)
      this.allview = true
      this.onAll = false
      this.currentNum = row
      this.currentRowTitle = row
      // var currentID = isMobile === 'mobile' ? row : row.id
      var currentID = row.id
      try {
        const detailData = await this.$http.get('MDM/Geofences/Detail', {
          params: {
            id: currentID,
            date: this.selectDate
          }
        })
        this.currentRow = detailData.data
        console.log(detailData)
        if (this.currentRow.length <= 0) {
          this.noResultDetail = true
        } else {
          this.noResultDetail = false
        }
        this.isLoading = false
      } catch (error) {
        console.log(error)
      }
    },
    dateFormatter: function (aDate) {
      console.log(aDate)
      return this.$Formatter.dateGeo(aDate * 1000)
    },
    cellStyle: function () {
      return 'padding: 0'
    }
  },
  created: function () {
    this.getGeofencesdatas()
  },
  mounted: function () {
    this.getGeofencesdatas()
  },
  watch: {
    '$route' (to, from) {
      console.log(to, from)
      if (to.name === from.name) {
        this.getGeofencesdatas()
      }
    }
  }
}
</script>

<style scoped>
  .scrollbars_pc {
    width:40%;height:100%;
  }
  .GeofencesAside_pc {
    width: 60% !important;
  }
  .defaultView{
    margin-top: 30px;
    color: #777777;
  }
  .allgeofences{
    width:100%;
    height:9%;
    line-height:70px;
    box-sizing:border-box;
    border-bottom:1px solid #e4e8ec;
    padding:0;
  }
  .allgeofences:hover{
    background-color:#fff;
    cursor: pointer;
  }
  .allgeofences:hover .nullBorder{
    transition: .5s;
    background-color: #2bcf88;
  }
  .geofencesPosition{
    position:relative;
  }
  .addBox{
    z-index:9;
    position:absolute;
    bottom:80px;
    right:10px;
    color:#2bcf88;
  }
  .addBox:hover{
    color:#4D4D4D;
    cursor: pointer;
  }
  .el-table__row:hover .nullBorder{
    background-color:#2bcf88;
    transition: .5s;
  }
  .messageTitle{
    width:200px;
    font-size:15px;
    color:#333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
  }
  .geofencesPosition{
    position:relative;
  }
  .geofencesDelete {
    position:absolute;
    top:30%;
    left:90%;
    font-size:16px;
    /* color:#03AEF4; */
    cursor: pointer;
    /* display:none; */
  }
  .GeofencesAside{
    padding:20px 0;
    border-left:1px solid #e5e7ed;
    border-top:1px solid #e5e7ed;
  }
  .asideText{
    /* max-height:550px; */
    /* overflow-y: outo; */
    padding: 0 20px;
  }
  .asideText .detailBox{
    height:29px;
    padding: 15px 10px;
    display:flex;
    display: -mz-flexbox;
    justify-content: space-between;
    border-bottom:1px solid #e5e7ed;
    line-height: 29px;
  }
  .geolocation{
    color:#7c7c7c;
    font-size:15px;
    padding-top:16px;
    padding-left:10px;
  }
  .dateFont{
    color:#7c7c7c;
    font-size:15px;
  }
  .select_date {
    font-size:16px;
    padding-bottom: 20px;
    font-weight:600;
    padding-right: 10px;
    border-bottom: 1px solid #e5e5e5;
  }
  .select_time {
    width: 160px;
  }
.blueBorder{
  width:6px;
  height:71px;
  float:left;
  margin-left:-10px;
  background-color: #2bcf88!important;
  border-left:1px solid #e4e8ec;
}
.nullBorder{
  width:6px;
  height:71px;
  float:left;
  margin-left:-10px;
  background:transparent;
  border-left:1px solid #e4e8ec;
}
.Out_in {
  color: #ff7e55;
}
.Out_ins {
  color: #2bcf88;
}
.buy-footer-btn {
  height: 48px;
  width: 180px !important;
  font-size: 18px;
}
.defaultView_nodata {
  line-height: 30px;
  color: #777777;
}

  @media (min-width: 1024px) {
    .addBox{
      z-index:9;
      position:absolute;
      bottom:30px;
      right:34%;
      color:#03aef4;
    }
     .view-box-padding{
      height: 92%;
    }
  }
  @media (max-width: 1024px) {
    .iphone_sm {
      display: -moz-box;  /* Firefox */
      display: -ms-flexbox;    /* IE10 */
      display: -webkit-box;    /* Safari */
      display: -webkit-flex;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      align-items: center;
      background-color: #E6EEEB;
    }
    .scrollbars_pc {
      width:100%;
      height: 570px;
      margin-bottom: 20px;
      background-color: #fff;
      border-radius: 20px;
    }
    .GeofencesAside_pc {
      width: 100% !important;
      height: 570px;
      background-color: #fff;
      border-radius: 20px;
    }
    .addBox{
      z-index:9;
      position:absolute;
      bottom:30px;
      right:33%;
      color:#03aef4;
    }
    .geofences_nodata{
      width:100% !important;
      background-color: #fff;
      border-radius: 20px;
    }
  }
  @media (max-width: 768px) {
    .addBox{
      z-index:9;
      position:absolute;
      bottom:30px;
      right:36%;
      color:#03aef4;
    }
  }
  @media (max-width: 414px) {
     .addBox{
      z-index:9;
      position:absolute;
      bottom:30px;
      right:26%;
      color:#03aef4;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Geofences.vue